import { render, staticRenderFns } from "./MPopupMenuGenre.vue?vue&type=template&id=875075e6&"
import script from "./MPopupMenuGenre.vue?vue&type=script&lang=ts&"
export * from "./MPopupMenuGenre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports